<template>
    <div
        :class="{ 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-range">
        <div class="l-ss-c-multi-range-slider-wrapper">
            <input
                type="range"
                class="l-ss-c-multi-range-slider-input"
                :min="filter.minValue"
                :max="filter.maxValue"
                :value="minValueNumber || filter.minValue"
                ref="inputLeft"
                @input="setLeftValue($event)">
            <input
                type="range"
                class="l-ss-c-multi-range-slider-input"
                :min="filter.minValue"
                :max="filter.maxValue"
                :value="maxValueNumber || filter.maxValue"
                ref="inputRight"
                @input="setRightValue($event)">

            <div class="l-ss-c-multi-range-slider">
                <div class="l-ss-c-multi-range-slider-track"></div>
                <div
                    class="l-ss-c-multi-range-slider-range"
                    ref="range"></div>
                <div
                    class="l-ss-c-multi-range-slider-thumb l-ss-c-multi-range-slider-thumb-left"
                    ref="thumbLeft"></div>
                <div
                    class="l-ss-c-multi-range-slider-thumb l-ss-c-multi-range-slider-thumb-right"
                    ref="thumbRight"></div>
            </div>
        </div>

        <c-label
            v-if="showTitle"
            :label="filterLabel"/>
        <div class="l-ss-c-filters-filter-range-ranges">
            <div
                class="l-ss-c-filters-filter-range-input-wrapper"
                ref="priceFromInputWrapper">
                <span class="l-ss-c-filters-filter-range-range-input-prefix">
                    {{ $t('filters.from') }}
                </span>
                <input
                    v-model="minValue"
                    :placeholder="placeholderMinValue"
                    class="l-ss-c-input l-ss-c-filters-filter-range-range-input"
                    type="tel"
                    :maxlength="String(filter.maxValue).length + 2"
                    @focus="onFocusPriceInput('priceFromInputWrapper')"
                    @blur="onBlurMinPrice('priceFromInputWrapper')"
                    @input="onInputMinPrice"
                    @change="onChangeMinPrice">
            </div>
            <div
                class="l-ss-c-filters-filter-range-input-wrapper"
                ref="priceToInputWrapper">
                <span class="l-ss-c-filters-filter-range-range-input-prefix">
                    {{ $t('filters.to') }}
                </span>
                <input
                    v-model="maxValue"
                    :placeholder="placeholderMaxValue"
                    class="l-ss-c-input l-ss-c-filters-filter-range-range-input"
                    type="tel"
                    :maxlength="String(filter.maxValue).length + 2"
                    @focus="onFocusPriceInput('priceToInputWrapper')"
                    @blur="onBlurMaxPrice('priceToInputWrapper')"
                    @input="onInputMaxPrice"
                    @change="onChangeMaxPrice">
            </div>
        </div>
        <transition name="fade">
            <button
                v-if="isShowSaveButton"
                class="l-ss-c-filters-save-button l-ss-c-button"
                @click="onClickApply">
                {{ $t('filters.applyPrice') }}
            </button>
        </transition>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';
    import debounce from '@/core/helpers/debounce';

    const RANGE_CHANGE_DELAY = 800;
    const BACKSPACE_KEY_CODE = 8;
    const DEBOUNCE_TIMER = 100;

    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        data() {
            return {
                minValue: '',
                maxValue: '',
                oldMinValue: '',
                newMinValue: null,
                newMaxValue: null,
                minValueNumber: null,
                maxValueNumber: null,
                isPriceInputFocused: false,
            };
        },
        computed: {
            name() {
                return `${this.filter.name}`;
            },
            placeholderMinValue() {
                return this.getPlaceholder(this.filter.minValue, this.symbol);
            },
            placeholderMaxValue() {
                return this.getPlaceholder(this.filter.maxValue, this.symbol);
            },
            isShowSaveButton() {
                return this.isPriceInputFocused;
            },
            customUnit() {
                const filterId = this.filter.id;
                const currentFilterConfig = this.$configuration.filterConfig[filterId];

                if (currentFilterConfig?.unit) {
                    return currentFilterConfig.unit;
                }

                return '';
            },
        },
        watch: {
            filterValue: {
                handler(value) {
                    this.minValue = value?.min ? this.addCurrency(value.min, this.symbol) : '';
                    this.maxValue = value?.max ? this.addCurrency(value.max, this.symbol) : '';
                },
                immediate: true,
            },
            isShowSaveButton(value, prevValue) {
                if (value !== prevValue) {
                    this.$nextTick(() => {
                        this.$emit('change-size');
                    });
                }
            },
        },
        created() {
            // Объявляем функцию так, чтобы в ней была функция cancel.
            this.setRangeSliderPositions = debounce(function () {
                this.setLeftValue();
                this.setRightValue();
            }, DEBOUNCE_TIMER);
        },
        mounted() {
            this.setRangeSliderPositions();
        },
        updated() {
            this.setRangeSliderPositions();
        },
        beforeDestroy() {
            this.setRangeSliderPositions.cancel();
            clearTimeout(this.emitTimer);
        },
        methods: {
            getPlaceholder(value, symbol) {
                return `${value.toLocaleString()} ${this.customUnit || symbol}`;
            },
            onInputMinPrice(event) {
                let value = event.target.value;
                this.minValue = this.currencyRemove(value, this.symbol).replace(/[^\d]/g, '');
            },
            onInputMaxPrice(event) {
                let value = event.target.value;
                this.maxValue = this.currencyRemove(value, this.symbol).replace(/[^\d]/g, '');
            },
            onChangeMinPrice(event, currentValue = null) {
                let value = currentValue ? currentValue : event.target.value;
                value = value === '' ? '' : value;

                this.newMinValue = this.currencyRemove(value, this.symbol).replace(/[^\d]/g, '');
                if (event.keyCode === BACKSPACE_KEY_CODE && this.newMinValue !== '') {
                    const arr = this.newMinValue.split('');
                    this.newMinValue = arr.slice(0, this.newMinValue.length - 1).join(',');
                }
                if (this.currencyRemove(this.newMinValue, this.symbol) === '') {
                    this.newMinValue = '';
                }

                if (this.maxValue) {
                    const maxValueWithoutCurrency = this.currencyRemove(this.maxValue, this.symbol);

                    if (this.newMinValue && +this.newMinValue > +maxValueWithoutCurrency) {
                        this.newMinValue = maxValueWithoutCurrency;
                    }
                }

                if (this.newMinValue !== '') {
                    this.minValue = this.addCurrency(this.newMinValue, this.symbol);
                } else {
                    this.minValue = '';
                }

                this.runEmitRangeChange(event);

                this.isPriceInputFocused = false;
            },
            onChangeMaxPrice(event, currentValue = null) {
                let value = currentValue ? currentValue : event.target.value;
                value = value === '' ? '' : value;

                if (value && +value > this.filter.maxValue) {
                    value = `${this.filter.maxValue}`;
                }

                this.newMaxValue = this.currencyRemove(value, this.symbol).replace(/[^\d]/g, '');

                if (event.keyCode === BACKSPACE_KEY_CODE && this.newMaxValue !== '') {
                    const arr = this.newMaxValue.split('');
                    this.newMaxValue = arr.slice(0, this.newMaxValue.length - 1).join(',');
                }
                if (this.currencyRemove(this.newMaxValue, this.symbol) === '') {
                    this.newMaxValue = '';
                }

                if (this.minValue) {
                    const minValueWithoutCurrency = this.currencyRemove(this.minValue, this.symbol);

                    if (this.newMaxValue && +this.newMaxValue < +minValueWithoutCurrency) {
                        this.newMaxValue = minValueWithoutCurrency;
                    }
                }

                if (this.newMaxValue !== '') {
                    this.maxValue = this.addCurrency(this.newMaxValue, this.symbol);
                } else {
                    this.maxValue = '';
                }

                this.runEmitRangeChange(event);

                this.isPriceInputFocused = false;
            },
            runEmitRangeChange(event) {
                if (this.emitTimer) {
                    clearTimeout(this.emitTimer);
                }
                this.emitTimer = setTimeout(() => {
                    const { minValue, maxValue } = this;
                    const formatMinValue = +this.currencyRemove(minValue, this.symbol);
                    const formatMaxValue = +this.currencyRemove(maxValue, this.symbol);
                    const range = {};
                    if (minValue !== '' && !isNaN(formatMinValue)) {
                        range.min = formatMinValue !== 0 ? formatMinValue : undefined;
                    }
                    if (maxValue !== '' && !isNaN(formatMaxValue)) {
                        range.max = formatMaxValue !== 0 ? formatMaxValue : undefined;
                    }
                    if (range.max !== undefined || range.min !== undefined) {
                        range.condition = 'range';

                        const { min, max } = range;

                        const trackValue = {
                            min,
                            max,
                        };

                        this.onChange(range);
                        this.onFilterClick(event, trackValue);
                    } else {
                        this.onChange();
                        this.onFilterClick(event);
                    }
                }, RANGE_CHANGE_DELAY);
            },
            onFocusPriceInput(priceInputWrapperRefName) {
                this.isPriceInputFocused = true;
                clearTimeout(this.emitTimer);
                this.setFocusedBorder(priceInputWrapperRefName);
            },
            onBlurMinPrice(priceInputWrapperRefName) {
                this.isPriceInputFocused = false;
                this.removeFocusedBorder(priceInputWrapperRefName);
            },
            onBlurMaxPrice(priceInputWrapperRefName) {
                this.isPriceInputFocused = false;
                this.removeFocusedBorder(priceInputWrapperRefName);
            },
            setFocusedBorder(priceInputWrapperRefName) {
                const priceWrapperElement = this.$refs[priceInputWrapperRefName];
                priceWrapperElement.classList.add('-focused');
            },
            removeFocusedBorder(priceInputWrapperRefName) {
                const priceWrapperElement = this.$refs[priceInputWrapperRefName];
                priceWrapperElement.classList.remove('-focused');
            },
            currencyRemove(value, currency) {
                if (currency) {
                    value = value.replaceAll(this.customUnit || currency, '');
                }

                return value.replace(/\s/g, '');
            },
            addCurrency(value, currency) {
                return ((+value.trim()).toLocaleString() + ` ${this.customUnit || currency}`).trim();
            },
            setLeftValue(event) {
                this.minValueNumber = this.currencyRemove(this.minValue, this.symbol) || this.filter.minValue;
                const inputLeft = this.$refs.inputLeft;
                const inputRight = this.$refs.inputRight;
                const min = parseInt(this.filter.minValue);
                const max = parseInt(this.filter.maxValue);

                if (!inputLeft || !inputRight) {
                    return;
                }

                inputLeft.value = Math.min(parseInt(inputLeft.value), parseInt(inputRight.value || this.filter.maxValue) - 1);
                const percent = ((inputLeft.value - min) / (max - min)) * 100;

                const thumbLeft = this.$refs.thumbLeft;
                const range = this.$refs.range;

                thumbLeft.style.left = percent + '%';
                range.style.left = percent + '%';

                const thumbLeftWidth = thumbLeft.offsetWidth;
                if (thumbLeftWidth) {
                    thumbLeft.style.transform = `translate(-${thumbLeftWidth / 100 * percent}px, -10px)`;
                }

                if (event) {
                    this.onChangeMinPrice(event, inputLeft.value);
                }
            },
            setRightValue(event) {
                this.maxValueNumber = this.currencyRemove(this.maxValue, this.symbol) || this.filter.maxValue;
                const inputRight = this.$refs.inputRight;
                const inputLeft = this.$refs.inputLeft;
                const min = parseInt(this.filter.minValue);
                const max = parseInt(this.filter.maxValue);

                if (!inputLeft || !inputRight) {
                    return;
                }

                inputRight.value = Math.max(parseInt(inputRight.value), parseInt(inputLeft.value || this.filter.minValue) + 1);
                const percent = ((inputRight.value - min) / (max - min)) * 100;

                const thumbRight = this.$refs.thumbRight;
                const range = this.$refs.range;

                thumbRight.style.right = 100 - percent + '%';
                range.style.right = 100 - percent + '%';

                const thumbRightWidth = thumbRight.offsetWidth;
                if (thumbRightWidth) {
                    thumbRight.style.transform = `translate(${thumbRightWidth - (thumbRightWidth / 100 * percent)}px, -10px)`;
                }

                if (event) {
                    this.onChangeMaxPrice(event, inputRight.value);
                }
            },
            onClickApply() {
                this.$nextTick(() => {
                    this.$emit('ready');
                });
            },
        },
    };
</script>
